import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { founders } from '../../data/mockData';
import { useLanguage } from '../../context/LanguageContext';
import { Separator } from '../ui/separator';

export default function AboutSection() {
  const { t } = useLanguage();
  const [sectionRef, isVisible] = useScrollReveal({ threshold: 0.15 });

  return (
    <section id="about" className="py-16 sm:py-24 lg:py-32 bg-[#111114]">
      <div ref={sectionRef} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 animate-reveal ${isVisible ? 'visible' : ''}`}>
        <div className="flex items-center gap-4 mb-12 sm:mb-16">
          <span className="text-[#c9a96e] text-xs font-semibold tracking-[0.25em] uppercase">{t('about_label')}</span>
          <div className="h-px flex-1 bg-[#2a2a30]" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16">
          <div>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#f0ebe3] leading-tight">
              {t('about_h2_1')}
              <span className="text-gold-gradient block mt-1">{t('about_h2_2')}</span>
            </h2>
            <Separator className="bg-[#c9a96e]/30 my-6 sm:my-8 w-24" />
            <p className="text-[#8a857e] text-sm sm:text-base lg:text-lg leading-relaxed">{t('about_text')}</p>
          </div>
          <div className="flex flex-col gap-5 sm:gap-6">
            <p className="text-[#9a9590] text-sm sm:text-base leading-relaxed">{t('about_extended')}</p>
            <p className="text-[#8a857e] text-sm sm:text-base leading-relaxed">{t('about_detail')}</p>
          </div>
        </div>

        <div className="mt-14 sm:mt-20">
          <h3 className="text-[#c9a96e] text-xs font-semibold tracking-[0.25em] uppercase mb-6 sm:mb-8">{t('about_founders')}</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {founders.map((founder, i) => (
              <div key={i} className="p-5 sm:p-6 border border-[#1e1e24] rounded-lg bg-[#0a0a0c]/50 service-card">
                <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#c9a96e]/10 flex items-center justify-center mb-4">
                  <span className="text-[#c9a96e] font-heading text-base sm:text-lg font-bold">
                    {founder.name.split(' ').map((n) => n[0]).slice(0, 2).join('')}
                  </span>
                </div>
                <h4 className="text-[#f0ebe3] font-medium text-sm mb-1">{founder.name}</h4>
                <p className="text-[#6a6560] text-xs">{t('about_formerly')} {founder.from}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
